// Chapter 1 Quiz Questions (16-30)

export const ch1Quiz2 = [
  {
    question: "Who regulates crop insurance agents in South Dakota?",
    options: [
      "USDA Risk Management Agency",
      "Federal Crop Insurance Corporation",
      "South Dakota Division of Insurance",
      "National Crop Insurance Services"
    ],
    correct: 2,
    explanation: "The SD Division of Insurance licenses producers, enforces ethical standards, and handles complaints against agents in South Dakota."
  },
  {
    question: "What does 'good farming practices' require of insured farmers?",
    options: [
      "Using the most expensive equipment available",
      "Following production methods generally recognized for the area",
      "Planting only one type of crop",
      "Purchasing the highest coverage level"
    ],
    correct: 1,
    explanation: "Good farming practices means using production methods generally recognized for the area—proper planting dates, seed selection, pest management, etc."
  },
  {
    question: "Which of the following is an example of physical hazard?",
    options: [
      "A farmer who exaggerates crop damage",
      "A low-lying field prone to flooding",
      "A farmer who neglects pest control",
      "Fluctuating commodity prices"
    ],
    correct: 1,
    explanation: "Physical hazard is a physical condition that increases loss likelihood. A flood-prone field is a physical characteristic that increases risk."
  },
  {
    question: "If a crop is damaged but still harvestable, the remaining production is called:",
    options: [
      "Replacement value",
      "Salvage value",
      "Actual cash value",
      "Market value"
    ],
    correct: 1,
    explanation: "Salvage value is the remaining value of damaged property. Harvestable production offsets the indemnity payment."
  },
  {
    question: "A cash rent tenant has what level of insurable interest in the crops?",
    options: [
      "No insurable interest",
      "Partial interest equal to their rent payment",
      "Full interest—pays fixed rent, keeps all production",
      "Interest equal to landlord's share"
    ],
    correct: 2,
    explanation: "Cash rent tenants pay fixed rent regardless of production, so they have full insurable interest in the crop they produce."
  },
  {
    question: "The Risk Management Agency (RMA) does all of the following EXCEPT:",
    options: [
      "Establishes sales closing dates",
      "Develops actuarial documents",
      "Sells policies directly to farmers",
      "Oversees compliance"
    ],
    correct: 2,
    explanation: "RMA administers the program but does NOT sell policies directly. AIPs sell policies to farmers; RMA provides oversight."
  },
  {
    question: "What is the relationship between FCIC and RMA?",
    options: [
      "They are competing private companies",
      "RMA administers crop insurance programs on behalf of FCIC",
      "FCIC regulates RMA's activities",
      "They are the same organization"
    ],
    correct: 1,
    explanation: "FCIC is the legal entity providing crop insurance; RMA is the USDA agency that administers the programs on FCIC's behalf."
  },
  {
    question: "Production risk in agriculture refers to uncertainty about:",
    options: [
      "Commodity prices at harvest",
      "Crop yields due to weather, pests, and disease",
      "Interest rates on operating loans",
      "Changes in government regulations"
    ],
    correct: 1,
    explanation: "Production risk is uncertainty about yields due to factors like weather, pests, and disease. Price risk concerns commodity prices."
  },
  {
    question: "Assignment of a crop insurance policy:",
    options: [
      "Transfers all policy rights to a third party",
      "Transfers only the right to receive payment to a third party",
      "Cancels the policy immediately",
      "Is prohibited under federal law"
    ],
    correct: 1,
    explanation: "Assignment transfers the right to receive indemnity payment (often to a lender) but NOT the policy itself. The farmer remains insured with all duties."
  },
  {
    question: "Why is the 1994 Federal Crop Insurance Reform Act significant?",
    options: [
      "It eliminated all crop insurance programs",
      "It introduced catastrophic (CAT) coverage",
      "It ended premium subsidies",
      "It transferred programs to state control"
    ],
    correct: 1,
    explanation: "The 1994 Reform Act introduced CAT (catastrophic) coverage, making basic protection more accessible to all farmers."
  },
  {
    question: "What prevents crop insurance from becoming a vehicle for profit?",
    options: [
      "The principle of subrogation",
      "The principle of indemnity",
      "Physical hazards",
      "Coverage level limits"
    ],
    correct: 1,
    explanation: "The indemnity principle ensures insurance restores you to pre-loss position—no better. This prevents profit motive from causing moral hazard."
  },
  {
    question: "The Standard Reinsurance Agreement (SRA) governs the relationship between:",
    options: [
      "Farmers and their agents",
      "AIPs and the federal government",
      "RMA and state regulators",
      "Landlords and tenants"
    ],
    correct: 1,
    explanation: "The SRA establishes how AIPs share risk with the federal government, including premium handling and loss sharing arrangements."
  },
  {
    question: "Which is NOT an insured peril typically covered by crop insurance?",
    options: [
      "Drought",
      "Hail",
      "Low market prices alone",
      "Excess moisture"
    ],
    correct: 2,
    explanation: "Low market prices alone are speculative risk, not insurable. However, Revenue Protection does address price declines through revenue guarantees."
  },
  {
    question: "When must insurable interest exist for crop insurance?",
    options: [
      "Only at policy purchase",
      "Only at harvest time",
      "At the time of loss",
      "Throughout the entire policy period"
    ],
    correct: 2,
    explanation: "For crop insurance, insurable interest must exist at the time of loss. This is important for situations involving leases or land sales mid-season."
  },
  {
    question: "A hailstorm destroying a wheat crop is an example of:",
    options: [
      "A hazard",
      "A peril",
      "Morale hazard",
      "Speculative risk"
    ],
    correct: 1,
    explanation: "Hail is a peril—the actual cause of loss. A hazard would be a condition that makes hail damage more likely or severe."
  }
];
